// Path: ./src/utils/dateUtil/setTimeTo1201AM.ts
export function setValidationStartTimeTo1201AM(date: Date | string): Date {
  // Convert string to Date if necessary
  const inputDate = typeof date === "string" ? new Date(date) : date;

  // Clone the date to avoid mutating the original date
  const torontoDate = new Date(inputDate.getTime());

  // Set time to 12:01AM in Toronto's local time
  torontoDate.setHours(0, 1, 0, 0);

  // Find out the UTC offset for Toronto at that date
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Toronto",
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZoneName: "short",
  });

  // Get the formatted time string and extract the offset
  const parts = formatter.formatToParts(torontoDate);
  const offsetPattern = parts
    .find((part) => part.type === "timeZoneName")
    ?.value.match(/GMT([+-]\d{2})(\d{2})/);

  // Calculate the offset in minutes
  const offsetMinutes = offsetPattern
    ? parseInt(offsetPattern[1]) * 60 + parseInt(offsetPattern[2])
    : 0;

  // Convert Toronto time to UTC by subtracting the offset
  torontoDate.setMinutes(torontoDate.getMinutes() - offsetMinutes);

  return torontoDate;
}
